import { NotificationApiService } from './service/NotificationApiService';

export const notificationApiService: NotificationApiService = new NotificationApiService();
